module.exports = __webpack_public_path__ + "static/media/Maax-Regular.f67fc4d3.woff";